import { Suspense } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import AboutHero from './components/AboutHero';
import MissionVision from './components/MissionVision';
import WhyInsurance from './components/WhyInsurance';
import { useSEO } from '../../utils/seo';

export default function AboutPage() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
  
  useSEO({
    title: 'Hakkımızda - Sigorta360 | Sigorta Sektörüne Özel Dijital Ajans',
    description: 'Sigorta360, sigorta acentelerinin dijital dönüşümünde öncü bir ajans olarak, sektöre özel çözümler sunuyoruz. Misyonumuz, vizyonumuz ve ekibimiz hakkında bilgi edinin.',
    keywords: 'sigorta360 hakkında, dijital ajans, sigorta pazarlama ekibi, sigorta dijital dönüşüm, sigorta ajans',
    canonical: `${siteUrl}/hakkimizda`,
    schema: {
      '@context': 'https://schema.org',
      '@type': 'AboutPage',
      name: 'Hakkımızda - Sigorta360',
      description: 'Sigorta acentelerinin dijital dönüşümünde öncü ajans',
      url: `${siteUrl}/hakkimizda`,
      mainEntity: {
        '@type': 'Organization',
        name: 'Sigorta360',
        description: 'Sigorta sektörüne özel dijital pazarlama ve teknoloji çözümleri',
        foundingDate: '2020',
        numberOfEmployees: '15-20'
      }
    }
  });

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <Suspense fallback={<div className="min-h-screen flex items-center justify-center">Yükleniyor...</div>}>
        <AboutHero />
        <MissionVision />
        <WhyInsurance />
      </Suspense>
      <Footer />
    </div>
  );
}
